import React from 'react';
import { Navigate } from 'react-router-dom';
import { getStaffHomeRoute, getStoredStaffRole } from '../utils/staffAuth';
import { clearStaffSession, isJwtExpired } from '../utils/runtimeConfig';

const ProtectedRoute = ({ children, allowedRoles = null }) => {
  const token = localStorage.getItem('ktc_token') || localStorage.getItem('access_token');

  if (!token) {
    return <Navigate to="/dadu/login" replace />;
  }

  if (isJwtExpired(token)) {
    clearStaffSession();
    return <Navigate to="/dadu/login" replace />;
  }

  const currentRole = getStoredStaffRole();
  const canAccess = !Array.isArray(allowedRoles) || allowedRoles.length === 0
    ? true
    : (
      allowedRoles.includes(currentRole)
      || (currentRole === 'superadmin' && allowedRoles.includes('admin'))
    );
  if (!canAccess) {
    return <Navigate to={getStaffHomeRoute(currentRole)} replace />;
  }

  return children;
};

export default ProtectedRoute;
